import { InventoryAdjustReason } from './inventory-adjust-reason.js';
export const INVENTORY_ADJUST_REASON_NAMES = {
    [InventoryAdjustReason.FOUND]: 'Found',
    [InventoryAdjustReason.MISSING]: 'Missing',
    [InventoryAdjustReason.CORRECTION]: 'Correction',
    [InventoryAdjustReason.DAMAGED]: 'Damaged / defective',
    [InventoryAdjustReason.FAILED_TESTING]: 'Failed testing',
    [InventoryAdjustReason.EXPIRED]: 'Expired',
    [InventoryAdjustReason.OTHER]: 'Other',
    [InventoryAdjustReason.UNRECORDED_PRODUCTION]: 'Unrecorded production',
    [InventoryAdjustReason.SCRAP_IN_ERROR]: 'Scrap recorded in error',
    [InventoryAdjustReason.RECEIPT_TO_WRONG_LOCATION]: 'Receipt to wrong location',
    [InventoryAdjustReason.RETURN_NOT_RECORDED]: 'Return not recorded',
    [InventoryAdjustReason.CONSUMPTION_NOT_RECORDED]: 'Consumption not recorded',
    [InventoryAdjustReason.SHIPMENT_NOT_RECORDED]: 'Shipment not recorded',
    [InventoryAdjustReason.DAMAGE_NOT_RECORDED]: 'Damage not recorded',
    [InventoryAdjustReason.MOVED_WITHOUT_RECORDING]: 'Moved without recording',
    [InventoryAdjustReason.THEFT_OR_LOSS]: 'Theft or loss',
    [InventoryAdjustReason.PRIOR_COUNT_WRONG]: 'Prior count was wrong',
    [InventoryAdjustReason.UOM_ERROR]: 'Unit of measure error',
    [InventoryAdjustReason.UNEXPLAINED_ACCEPTED]: 'Unexplained — accepted',
};
//# sourceMappingURL=inventory-adjust-reason-names.js.map